/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Modal, Button } from 'react-bootstrap'
import { postRequestOptions } from '../helpers/Fetchwrapper'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Spinner from 'react-bootstrap/Spinner'

interface ParentCompanyCreateProps {
	show: boolean;
	handleClose: any;
	id: number;
}

interface InitialState {
	name: string;
	binNumber: string;
	address: string;
}


const ParentCompanyCreate: React.FC<ParentCompanyCreateProps> = ({ show, handleClose, id }) => {

	const initialState: InitialState = {
		name: '',
		binNumber: '',
		address: '',
	};

	const [parentCompany, setParentCompany] = useState(initialState);

	useEffect(() => {
		if (!show) {
			return;
		}
		if (id !== 0) {
			const myToken: string | null = localStorage.getItem('MyToken');
			let jwt: string | null = (myToken != null) ? JSON.parse(myToken) : null;
			fetch(`${process.env.REACT_APP_API_URL}parent-company/details/${id}`, {
				headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwt}` }
			})
				.then((resp: Response) => {
					return resp.json();
				})
				.then((resp: any) => {
					setParentCompany({ ...resp, address: resp.address || '' });
				})
				.catch((error: any) => {
					console.log(error, 'catch the hoop');
				});
		} else {
			setParentCompany(initialState)
		}
	}, [id, show]);


	const [isSubmitDisable, setSubmitDisable] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleChange = (e: any) => {
		setParentCompany({ ...parentCompany, [e.target.name]: e.target.value });
	};

	const parentCompanySave = async (event: any) => {
		event.preventDefault()
		setSubmitDisable(true);
		setLoading(true);
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: `You want to ${id === 0 ? 'create' : 'update'} this Parent Company?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Submit it!',
		})
		if (confirm.value) {
			const requestOptions = postRequestOptions(parentCompany)
			try {
				let url = '';
				if (id === 0) {
					url = `${process.env.REACT_APP_API_URL}parent-company/create`
				} else {
					url = `${process.env.REACT_APP_API_URL}parent-company/update`
				}

				let response = await fetch(
					url,
					requestOptions
				)

				let respData = await response.json()
				if (respData.success === true) {
					const successMsg = respData.successMessage
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: successMsg,
					})
					handleClose(respData.success)
				} else {
					const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
					Swal.fire({
						icon: 'error',
						title: 'Error',
						html: errorsMessage,
					})
				}
			} catch (error) {
				console.log(error, 'catch the hoop')
			}
		}
		setSubmitDisable(false);
		setLoading(false);
	}


	return (
		<Modal show={show} onHide={() => handleClose(false)} size="lg">
			<form onSubmit={parentCompanySave}>
				<Modal.Header closeButton>
					<Modal.Title>{id === 0 ? 'Create' : 'Edit'} Parent Company</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
						<label htmlFor="name" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Name <span className="required text-danger"></span></label>
						<div className="col-lg-7">
							<input type="text" name="name" id="name" value={parentCompany.name} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="binNumber" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>BIN Number <span className="required text-danger"></span></label>
						<div className="col-lg-7">
							<input type="text" name="binNumber" id="binNumber" value={parentCompany.binNumber} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="address" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Address </label>
						<div className="col-lg-7">
							<textarea name="address" id="address" value={parentCompany.address} onChange={handleChange} className="form-control form-control-sm" rows={3}></textarea>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>

					<button type="submit" disabled={isSubmitDisable || loading} className="btn btn-sm btn-primary me-2">
						{loading &&
							<Spinner
								as="span"
								animation="grow"
								size="sm"
								role="status"
								aria-hidden="true"
							/>
						}
						<span>  Submit</span>
					</button>
					<Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
						Close
					</Button>
				</Modal.Footer>
			</form>
		</Modal>
	)
}

export default ParentCompanyCreate
